import React from "react";
import { useNavigate } from "react-router-dom";
import { C, panel } from "./consoleTheme";

export function BackBar({ label }) {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate("/console")}
      style={{
        background: "none", border: "none", color: C.textDim, cursor: "pointer",
        fontSize: 13, padding: 0, marginBottom: 16,
      }}
    >
      ← {label}
    </button>
  );
}

export function Panel({ title, children, right }) {
  return (
    <section style={{ ...panel, padding: 16, marginBottom: 14 }}>
      <div style={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", marginBottom: 12 }}>
        <h2 style={{ fontSize: 11, letterSpacing: 1, textTransform: "uppercase", color: C.textDim, margin: 0 }}>
          {title}
        </h2>
        {right}
      </div>
      {children}
    </section>
  );
}

export function Field({ label, value, mono }) {
  return (
    <div style={{ marginBottom: 10 }}>
      <div style={{ fontSize: 11, color: C.textFaint, marginBottom: 2 }}>{label}</div>
      <div style={{ fontSize: 14, fontFamily: mono ? C.mono : "inherit", wordBreak: "break-word" }}>
        {value === null || value === undefined || value === "" ? <span style={{ color: C.textFaint }}>—</span> : String(value)}
      </div>
    </div>
  );
}

export function Grid({ children, min = 180 }) {
  return (
    <div style={{ display: "grid", gridTemplateColumns: `repeat(auto-fit, minmax(${min}px, 1fr))`, gap: "0 18px" }}>
      {children}
    </div>
  );
}

/**
 * A named risk, not a number the reader has to interpret. A health panel that
 * shows "3" and leaves you to work out whether that is bad is one nobody acts
 * on.
 */
export function Flag({ level, text }) {
  const colour = level === "high" ? C.high : level === "medium" ? C.medium : C.low;
  return (
    <div style={{ display: "flex", gap: 10, alignItems: "flex-start", padding: "9px 0", borderTop: `1px solid ${C.border}` }}>
      <span style={{
        fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.6,
        color: colour, border: `1px solid ${colour}`, borderRadius: 3,
        padding: "1px 5px", flexShrink: 0, marginTop: 1,
      }}>
        {level}
      </span>
      <span style={{ fontSize: 13, lineHeight: 1.45 }}>{text}</span>
    </div>
  );
}

export function Stat({ label, value, tone }) {
  return (
    <div style={{ ...panel, padding: "12px 14px" }}>
      <div style={{ fontSize: 11, color: C.textFaint, marginBottom: 4 }}>{label}</div>
      <div style={{ fontSize: 22, fontWeight: 600, color: tone || C.text, fontVariantNumeric: "tabular-nums" }}>
        {value ?? "—"}
      </div>
    </div>
  );
}

export function StateScreen({ children }) {
  return (
    <div style={{ background: C.bg, minHeight: "100vh", padding: "32px 28px", color: C.textDim }}>
      <div style={{ maxWidth: 900, margin: "0 auto" }}>{children}</div>
    </div>
  );
}

export function AuditList({ rows }) {
  if (!rows?.length) return <p style={{ fontSize: 13, color: C.textFaint, margin: 0 }}>No staff actions recorded.</p>;
  return (
    <div>
      {rows.map((a, i) => (
        <div key={i} style={{ padding: "8px 0", borderTop: i ? `1px solid ${C.border}` : "none", fontSize: 13 }}>
          <div style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
            <span style={{ fontFamily: C.mono, color: C.brand }}>{a.action}</span>
            <span style={{ color: C.textFaint, fontSize: 12, whiteSpace: "nowrap" }}>
              {a.at ? new Date(a.at).toLocaleString() : ""}
            </span>
          </div>
          <div style={{ color: C.textDim, fontSize: 12, marginTop: 2 }}>
            {a.by}{a.reason ? ` — ${a.reason}` : ""}
          </div>
        </div>
      ))}
    </div>
  );
}
